var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Basic = require("../../../elements/Basic");

var _FontelloIcon = _interopRequireDefault(require("../Basic/FontelloIcon"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Formation/FormationSubstitutionItem.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var FormationSubstitutionItem = function (_React$Component) {
  (0, _inherits2.default)(FormationSubstitutionItem, _React$Component);

  var _super = _createSuper(FormationSubstitutionItem);

  function FormationSubstitutionItem() {
    (0, _classCallCheck2.default)(this, FormationSubstitutionItem);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(FormationSubstitutionItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          even = _this$props.even,
          away = _this$props.away,
          substitution = _this$props.substitution,
          itemStyle = _this$props.itemStyle;
      if (!substitution) return null;
      var playerIn = substitution.playerIn,
          playerOut = substitution.playerOut,
          minute = substitution.minute;
      return _react.default.createElement(_Basic.Row, {
        flexing: true,
        my: 1,
        p: 2,
        borderX: itemStyle ? itemStyle.borderX : 1,
        borderY: itemStyle ? itemStyle.borderY : 1,
        borderColor: "border.main",
        bg: even ? (0, _get.default)(itemStyle, 'evenBg') : (0, _get.default)(itemStyle, 'oddBg'),
        reverseRow: away,
        overflow: "hidden",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 18,
          columnNumber: 13
        }
      }, _react.default.createElement(_Basic.Text, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29,
          columnNumber: 17
        }
      }, minute, "'"), _react.default.createElement(_Basic.Column, {
        minWidth: 0,
        flexing: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33,
          columnNumber: 17
        }
      }, _react.default.createElement(_Basic.Row, {
        mb: 1,
        reverseRow: away,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34,
          columnNumber: 21
        }
      }, _react.default.createElement(_FontelloIcon.default, {
        px: 1,
        name: "exchange-in",
        color: "green",
        width: 20,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35,
          columnNumber: 25
        }
      }), playerIn ? _react.default.createElement(_Basic.Text, {
        grow: true,
        numberOfLines: 1,
        alignRight: away,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37,
          columnNumber: 29
        }
      }, playerIn.nickName || playerIn.lastName) : null), _react.default.createElement(_Basic.Row, {
        reverseRow: away,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 42,
          columnNumber: 21
        }
      }, _react.default.createElement(_FontelloIcon.default, {
        px: 1,
        name: "exchange-out",
        color: "red",
        width: 20,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43,
          columnNumber: 25
        }
      }), playerOut ? _react.default.createElement(_Basic.Text, {
        grow: true,
        numberOfLines: 1,
        alignRight: away,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45,
          columnNumber: 29
        }
      }, playerOut.nickName || playerOut.lastName) : null)));
    }
  }]);
  return FormationSubstitutionItem;
}(_react.default.Component);

FormationSubstitutionItem.propTypes = {
  away: _propTypes.default.bool,
  substitution: _propTypes.default.object
};
FormationSubstitutionItem.defaultProps = {
  away: false
};
var _default = FormationSubstitutionItem;
exports.default = _default;